import React from 'react'
import { AgTechTourConfig } from '../../../../Tour/AgTechTourTypes'
import { useAgTechTour } from '../../../../Tour/AgTechTourContext'

type AgTechSideNavigationHelpButtonProps = {
    tourConfig: AgTechTourConfig
    isCollapsed: boolean
}

const AgTechSideNavigationHelpButton = ({ tourConfig, isCollapsed }: AgTechSideNavigationHelpButtonProps) => {
    const { startTour } = useAgTechTour()

    return (
        <div
            className={`column-based items-center cursor-pointer text-appSideNavFont hover:text-highlight transition-colors px-6 py-3 ${isCollapsed ? 'justify-center' : ''}`}
            onClick={() => startTour(tourConfig)}
            title={isCollapsed ? 'Start Tour' : undefined}
        >
            <i className="bi bi-question-circle text-lg" />
            {!isCollapsed && (
                <span className="ml-3 text-sm">Help</span>
            )}
        </div>
    )
}

export default AgTechSideNavigationHelpButton
